import isEmpty from "lodash/isEmpty"
import includes from "lodash/includes"
import { VALID_ROOT_PATHS } from "constants-lib/common"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

// JSON LD template for WebsiteTemplate
export const websiteJSONLD = () => {
  const websiteTemplate = {
    "@context": "http://www.schema.org",
    "@type": "WebSite",
    name: "WM",
    alternateName: "Waste Management",
    id: "https://www.wm.com/#Website",
    url: "https://www.wm.com/",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://www.wm.com/us/en/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  }
  return websiteTemplate
}

export const brandJSONLD = () => ({
  "@context": "https://schema.org",
  "@type": "Brand",
  "@id": "https://www.wm.com/#brand",
  name: "WM",
  alternateName: "Waste Management",
  logo: "https://wm.com/content/dam/wm/icons/branding/wm-logo-web-header-footer.png",
  slogan: "Always Working For A Sustainable Tomorrow",
  url: "https://www.wm.com",
})

// JSON LD template for organizationJSONLD
export const organizationJSONLD = () => {
  const organizationTemplate = {
    "@context": "http://www.schema.org",
    "@type": "Organization",
    name: "WM",
    id: "https://www.wm.com/#Organization",
    url: "https://www.wm.com/",
    sameAs: [
      "https://www.facebook.com/WasteManagement/",
      "https://www.instagram.com/wastemanagement/",
      "https://twitter.com/WasteManagement",
      "https://www.linkedin.com/company/waste-management/",
      "https://www.youtube.com/user/wastemanagement",
    ],
    logo: "https://wm.com/content/dam/wm/icons/branding/wm-logo-web-header-footer.png",
    image:
      "https://wm.com/content/dam/wm/icons/branding/wm-logo-web-header-footer.png",
    description:
      "Waste Management, Inc. is an American waste management, comprehensive waste, and environmental services company in North America. Founded in 1968, the company is headquartered in the Bank of America Tower in Houston, Texas.",
    alternateName: [
      "Waste Management",
      "Waste Management National Services, Inc.",
    ],
    address: {
      "@type": "PostalAddress",
      streetAddress: "800 Capitol Street, Suite 3000",
      addressLocality: "Houston",
      addressRegion: "TX",
      postalCode: "77002",
      addressCountry: "United States",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+1(800) 796-9696",
      contactType: "customer service",
    },
  }
  return organizationTemplate
}

export const pathname = () => window.location.pathname.replace(/\/$/, "")

/* Add Website JSON LD if needed, otherwise make sure it does not exist in Head. */
export const updateWebsiteJSONLD = () => {
  if (
    (includes(VALID_ROOT_PATHS, pathname()) || isEmpty(pathname())) &&
    document.getElementById(`websiteJSONLD`) === null
  ) {
    const script = websiteJSONLD()
    addJSONLDToHead(script, `websiteJSONLD`)
  } else {
    removeElement(`websiteJSONLD`)
  }
}

/* Add brand JSON LD if needed, otherwise make sure it does not exist in Head. */
export const updatebrandJSONLD = () => {
  if (
    (includes(VALID_ROOT_PATHS, pathname()) || isEmpty(pathname())) &&
    document.getElementById(`brandJSONLD`) === null
  ) {
    const script = brandJSONLD()
    addJSONLDToHead(script, `brandJSONLD`)
  } else {
    removeElement(`brandJSONLD`)
  }
}

/* Add Website JSON LD if needed, otherwise make sure it does not exist in Head. */
export const updateOrganizationJSONLD = () => {
  if (
    (includes(VALID_ROOT_PATHS, pathname()) || isEmpty(pathname())) &&
    document.getElementById(`organizationJSONLD`) === null
  ) {
    const script = organizationJSONLD()
    addJSONLDToHead(script, `organizationJSONLD`)
  } else {
    removeElement(`organizationJSONLD`)
  }
}
